import sendEmailPrompt from "servicestack/email/send-email-prompt";
import $session from "servicestack/session";

export default ($parse) => ({
  scope: false,
  link(scope, element, attr) {
    const open = (e) => {
      var model = Object.assign(
        {
          subject: attr.subject || attr.title,
          from: attr.from || attr.fromEmail || attr.replyTo || $session.email,
          to: attr.to || attr.toEmail,
          message: attr.message || attr.body,
        },
        scope.$eval(attr.sendEmailPrompt || attr.ngModel)
      );

      return sendEmailPrompt(Object.assign({ model }, attr));
    };

    const $targets = attr.sendEmailPromptSelector
      ? element.find(attr.sendEmailPromptSelector)
      : element;
    $targets.on("click", open);
  },
});
